import axios from 'axios';
import React from 'react';
import d3 from 'd3';
import * as topojson from 'topojson-client';
import _ from 'lodash';
const CRUDECUTOFF = 600;
const PORTDEGDIFF = 4.4966;
const roundToNearest = function(n,nearestnum) {
    if(n > 0)
        return Math.ceil(n/nearestnum) * nearestnum;
    else if( n < 0)
        return Math.floor(n/nearestnum) * nearestnum;
    else
        return 0;
}


let portdata = {
    "Shanghai": {
        rank: 1,
        lines: [[120.916,31.224],[137.796,25.734],[160,25.734]],
    },
    "Singapore": {
        rank: 2,
        lines: [[103.567,1.315],[111.258,7.376]],
    },
    "Shenzhen": {
        rank: 3,
        lines: [[113.773,22.556],[121.349,20.220],[160,18]]
    },
    "Hong Kong": {
        rank: 4,
        lines: [[114.298,22.266],[121.349,20.220],[160,12]]    
    }
    
    
}


const π = Math.PI;
function miller(λ, φ) {
  return [
    λ,
    1.25 * Math.log(Math.tan(π / 4 + .4 * φ))
  ];
}

miller.invert = function(x, y) {
  return [
    x,
    2.5 * Math.atan(Math.exp(.8 * y)) - .625 * π
  ];
};

(d3.geo.miller = function() { return d3.geo.projection(miller); }).raw = miller;


const getCircleCenter = function(finalpoints,proj,d) {
    let x1 = proj(finalpoints[0])[0];
    let y1 = proj(finalpoints[0])[1];
    let x2 = proj(finalpoints[1])[0];
    let y2 = proj(finalpoints[1])[1];
    let D = Math.sqrt(Math.pow(x2-x1,2)+Math.pow(y2-y1,2));
    
    let x3 = x2 + (x2-x1) * d / D;
    let y3 = y2 + (y2-y1) * d / D;
    return [x3,y3];
}


let mapdata = null;
let mortalitydata = null;
let mortalitydata_crude = null;
let portindex = null;
export default class MortalityMap extends React.Component {
    constructor() {
        super(...arguments);
        this._drawWorld = _.debounce(this.drawWorld,300)
    }
    componentDidMount() {
        Promise.all(
            [axios.get("data/mortality.json"), axios.get("data/mortality-crude.json"),axios.get("data/world.json"),axios.get("data/portindex.json")]).then((responsearray) => {
           mortalitydata = responsearray[0].data;
           mortalitydata_crude = responsearray[1].data;
           mapdata = responsearray[2].data;
           portindex = responsearray[3].data;
           this.drawWorld();
        });
        
        
        
        
        
    }
    componentDidUpdate(oldprops,oldstate,oldcontext) {
        if(oldcontext.containerWidth && oldcontext.containerWidth != this.context.containerWidth) {
            this._drawWorld();
        }
    }
    getHeight(width) {
        return Math.ceil(width*1/1.9);        
    }
    getLegend(iscrude,bigradius) {
        let bubblespangen = (val,max,rmax) => `<span 
            style="width:${Math.sqrt(val/max)*rmax*2}px;height:${Math.sqrt(val/max)*rmax*2}px;opacity:${val/max};" class="legendbubble">
        </span>`;
        
        let genrow = (sym,text) => `<div class="legendrow" style="display:table-row">
            <div class="legendcell symbolcell" style="display:table-cell">
                ${sym}
            </div>
            <div class="legendcell" style="display:table-cell">
                ${text}
            </div>
        </div>`;
        let retstr = `<div class="mortalitylegend">
            <div class="legendtable" style="display:table">
                ${genrow(`<span class="eca1"></span>`,"Emission control area (sulfur and nitrogen oxides)")}
                ${genrow(`<span class="eca2"></span>`,"Emission control area (sulfur oxides only)")}
        `;
        
        if(iscrude) {
            //console.log(mortalitydata_crude.data.reduce((prev,cur) => cur[2]>prev?cur[2]:prev,0));
            let max = 3019.32;
            return retstr+`${genrow(bubblespangen(3000,max,bigradius),"3000 deaths/year")}
                ${genrow(bubblespangen(2000,max,bigradius),"2000")}
                ${genrow(bubblespangen(1000,max,bigradius),"1000")}
            `+"</div></div>"; 
        
            
        }
        let max = 1043.64;
        //console.log(mortalitydata.data.reduce((prev,cur) => cur[2]>prev?cur[2]:prev,0));
        return retstr+`${genrow(bubblespangen(1000,max,bigradius),"1000 deaths/year")}
                ${genrow(bubblespangen(750,max,bigradius),"750")}
                ${genrow(bubblespangen(500,max,bigradius),"500")}
                ${genrow(bubblespangen(250,max,bigradius),"250")}
            `+"</div></div>"; 
        
        
        
    }
    
    drawWorld() {
        if(mapdata == null) { return; }
        
        const svgwidth = this.props.width || this.context.containerWidth || 100;
        const svgheight = this.getHeight(svgwidth);
        const projection = d3.geo.miller().scale(112*svgwidth/705.094).translate([svgwidth / 2, svgheight / 1.6]);
        const path = d3.geo.path().projection(projection);
        const svg = d3.select(this.refs.map);
        svg.selectAll("*").remove();
        const noxecas = [2,4,5,6];
        
        svg.append("rect")
            .attr("x",projection([-180,90])[0])
            .attr("y",projection([-180,90])[1])
            .attr("width",projection([180,-90])[0]-projection([-180,90])[0])
            .attr("height",projection([180,-90])[1]-projection([-180,90])[1])
            .attr("fill","rgba(255,255,255,0)");
        
        svg.selectAll("path.ecaseca")
            .data(topojson.feature(mapdata,mapdata.objects.ecaseca).features)
            .enter()
            .append("path")
            .attr("class","ecaseca")
            .attr("d", path)
            .classed("eca1",(d,i) => noxecas.indexOf(i)>=0)
            .classed("eca2",(d,i) => noxecas.indexOf(i)<0)
            .style("stroke","none");
        
        svg.append("path")
            .datum(topojson.feature(mapdata,mapdata.objects.land))
            .attr("d", path)
            .attr("class","land")
            .style("fill","#fff")
            .style("stroke","#aaa")
            .style("stroke-width","1px");
            
        svg.append("path")
            .datum(topojson.feature(mapdata,mapdata.objects.borders))
            .attr("d", path)
            .style("fill","none")
            .attr("class","borders")
            .style("stroke","#aaa")
            .style("stroke-width","1px")
            .style("stroke-dasharray","3,1");
        
        svg.append("path")
            .datum(topojson.feature(mapdata,mapdata.objects.disputed))
            .attr("d", path)
            .attr("class","disputed")
            .style("fill","none")
            .style("stroke","#aaa")
            .style("stroke-width","1px");
            
        /*let lineFunction = d3.svg.line()
            .x(function(d) { return projection(d)[0]; })
            .y(function(d) { return projection(d)[1]; })
            .interpolate("linear");    
        for(let port in portdata) {
            let portobj = portdata[port];
            const radius = 8;
            const circlepadding = 1;
            const circleoffset = 2;
            console.log(lineFunction(portobj.lines));
            svg.append("path")
               .attr("class","ranklines")
               .attr("d",lineFunction(portobj.lines))
               .style("stroke","#000")
               .style("stroke-width","1px")
               .style("fill","none");
           let centerpoint = getCircleCenter(portobj.lines.slice(portobj.lines.length-2),projection,radius+circleoffset) 
           svg.append("circle")
               .attr("cx",centerpoint[0])
               .attr("cy",centerpoint[1])
               .attr("r",radius)
               .style("fill","#000")
               .style("stroke","none");
           
           svg.append("text")
               .text(""+portobj.rank)
               .style("stroke","none")
               .style("fill","#fff")
               .style("font-size", (2 * radius - 2* circlepadding) + "px")
               .style("dominant-baseline","middle")
               .style("text-anchor","middle") 
               .style("font-weight","500")
               .attr("x",centerpoint[0])
               .attr("y",centerpoint[1] + circlepadding)
        } */   
        let curmortalitydata;
        if(svgwidth<CRUDECUTOFF) {   
            curmortalitydata = mortalitydata_crude;    
        } else {
            curmortalitydata = mortalitydata;
            
        }
        let topleftscaler = projection([0,0]);
        let bottomrightscaler = projection([curmortalitydata.spacing,curmortalitydata.spacing]);
        let topradius = Math.min(Math.abs(bottomrightscaler[0]-topleftscaler[0]),Math.abs(bottomrightscaler[1]-topleftscaler[1]))/2;
        let toparea = Math.PI * topradius * topradius;
        let largestval = curmortalitydata.data.reduce((prev,cur) => cur[2]>prev?cur[2]:prev,0);
        
        svg.selectAll("circle.mortality").data(curmortalitydata.data).enter()
            .append("circle")
            .attr("class","mortality")
            .attr("r", d => Math.sqrt(d[2]*toparea/largestval/Math.PI))
            .attr("cx", d => projection([d[0],d[1]])[0])
            .attr("cy", d => projection([d[0],d[1]])[1])
            .style("opacity", d => d[2]/largestval)
            .style("fill","#e51c23")
            
        this.refs.legend.innerHTML=this.getLegend(svgwidth<CRUDECUTOFF,topradius);
        
        const tooltip = this.refs.tooltip;
        d3.select(this.refs.map).on("mouseover", function () {
            
        }).on("mouseout", function() {
            tooltip.style.visibility="hidden";    
        }).on("mousemove", function() {
            if(svgwidth<CRUDECUTOFF) { tooltip.style.visibility="hidden"; return; }
            const xy = d3.mouse(this);
            const lonlat = projection.invert(xy);
            tooltip.style.left=xy[0]+5+"px";
            tooltip.style.top=xy[1]+5+"px";
            let match = null;
            if(svgwidth<CRUDECUTOFF) {
                let matches = curmortalitydata.data.filter((coords) => Math.abs(coords[0]-lonlat[0])<2.5 && Math.abs(coords[1]-lonlat[1])<2.5);
                if(matches.length===1) {

                    match = matches[0];
                } else {
                    tooltip.style.visibility="hidden";    
                }
            } else {
                
                let matches = curmortalitydata.data.filter((coords) => Math.abs(coords[0]-lonlat[0])<1.5 && Math.abs(coords[1]-lonlat[1])<1.5);
                if(matches.length===1) {
                    
                    match = matches[0];
                } else {
                    tooltip.style.visibility="hidden";
                }
            }
            if(match) {
                let deaths = Math.floor(match[2]);
                /*let ports = topojson.feature(mapdata,mapdata.objects.ports).features;
                let matchedports = ports.filter((feature) => 
                    Math.abs(feature.geometry.coordinates[0]-match[0])< PORTDEGDIFF &&
                    Math.abs(feature.geometry.coordinates[1]-match[1])< PORTDEGDIFF);
                let portnames = matchedports.map((port) => port.properties.name);*/
                let matchedports = portindex.filter((port) => 
                    Math.sqrt(Math.pow(port[3]-match[0],2) + Math.pow(port[2]-match[1],2)) < PORTDEGDIFF);
                let portnames = matchedports.map((port) => port[0]);

                
                if(deaths>0) {
                    tooltip.style.visibility="visible";
                    tooltip.innerHTML = '<p class="mortalitytooltip_title">Ports within 500km:</p><p>'+portnames.join("</p><p>")+
                        '</p><p class="mortalitytooltip_deaths"><strong>Deaths: </strong>'+deaths+"</p>";
                }  else {
                    tooltip.style.visibility="hidden";
                }
            }
            
            
        });
        
        
        
        
    }
    render() {
        const svgwidth = this.props.width || this.context.containerWidth || 100;
        return <div style={{position:"relative"}}>
            <svg ref="map" width={svgwidth} height={this.getHeight(svgwidth)} className="mortalitysvg"/>
            <div ref="legend" className="mortalitylegendcontainer"></div>
            <div ref="tooltip" className="mortalitytooltip" style={{position:"absolute",zIndex:10000,"visibility":"hidden"}}className="mortalitytooltip"></div>
        </div>
        
    }
}

MortalityMap.contextTypes = {
    containerWidth: React.PropTypes.number
};


// WEBPACK FOOTER //
// ./src/js/components/special/MortalityMap/MortalityMap.jsx